import { render, staticRenderFns } from "./Sanitary.vue?vue&type=template&id=49a6357a&"
import script from "./Sanitary.vue?vue&type=script&lang=js&"
export * from "./Sanitary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports